








































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ResearchListMianxiang extends Vue {
  @Prop()
  private detail: any;
  private detailChange() {
    this.$emit("update:detail", this.detail);
  }
  private get message() {
    return this.detail.data;
  }
}
